import React, { PureComponent } from 'react';
import { Button, DialogContainer } from 'react-md';
import './TermsModal.css';

class TermsModal extends PureComponent {
	constructor(props) {
		super(props);

		this.state = { visible: false };

		this.show = this.show.bind(this);
		this.hide = this.hide.bind(this);
	}

	show = (e) => {
		e.preventDefault();
		this.setState({ visible: true });
	};

	hide = (e) => {
		this.setState({ visible: false });
	};

	render() {
		const { link, text } = this.props;
		const { visible } = this.state;
		const actions = [
			{
				onClick: this.hide,
				primary: true,
				children: 'Agree and Download File',
				href: link
			},
			{
				onClick: this.hide,
				primary: true,
				children: 'Cancel'
			}
		];

		return (
			<span>
				<a href="#" onClick={this.show}>
					{text}
				</a>
				<DialogContainer
					id="terms-modal"
					visible={visible}
					title="Terms & Conditions"
					onHide={this.hide}
					aria-describedby="terms-and-conditions"
					modal
					actions={actions}
					width="90%"
				>
					<div id="terms-modal" className="md-color--secondary-text">
						<p>By using OLLIE, you agree to the following:</p>
						<h3>No Legal or Business Advice</h3>
						<p>
							The resources found in OLLIE are intended for general informational and educational purposes
							only. Such materials are for informational purposes only and may not reflect the most
							current legal developments. These informational materials are not intended, and must not be
							taken, as legal advice on any particular set of facts or circumstances. You need to contact
							a lawyer licensed in your jurisdiction for advice on specific legal issues problems.
						</p>
						<h3>No Attorney-Client Relationship Created by Use of this Website</h3>
						<p>
							Neither your receipt of information from this website, nor your use of this website to
							contact the New Business Community Law Clinic (hereinafter “the Firm”) or one of its lawyers
							creates an attorney-client relationship between you and the Firm. You will become a client
							of the Firm only if and when you sign and engagement agreement setting forth the scope of
							the Firm’s engagement and other relevant matters. As a matter of policy, the Firm does not
							accept a new client without first investigating for possible conflicts of interests and
							obtaining a signed engagement letter. (The Firm may, for example, already represent another
							party involved in your matter.)
						</p>
						<h3>Links to Third Party Websites</h3>
						<p>
							As a convenience, this website provides links to various third-party websites. Such linked
							websites are not under the control of the Firm, and the Firm assumes no responsibility for
							the accuracy of the contents of such websites.
						</p>
						<h3>Authorized Practice of Law</h3>
						<p>
							The Firm does not seek, and this website is not intended to solicit, legal engagements in
							jurisdictions outside of our lawyers’ states of licensure when such engagements would
							constitute the unauthorized practice of law in any jurisdiction.
						</p>
						<h3>Disclaimer of Warranties</h3>
						<p>
							TO THE EXTENT PERMITTED BY LAW, THE DOCUMENTS LINKED IN OLLIE ARE PROVIDED AS-IS WITH NO
							REPRESENTATIONS OR WARRANTIES, EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO,
							IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
							TO THE EXTENT PERMITTED BY LAW, YOU ASSUME COMPLETE RESPONSIBILITY AND RISK FOR USE OF OLLIE
							AND ITS DOCUMENTS.
						</p>
						<h3>Limitation of Liability</h3>
						<p>
							IN NO EVENT SHALL THE NEW BUSINESS COMMUNITY LAW CLINIC, OR BERKELEY LAW, OR ANY OF ITS
							AFFILIATES, BE LIABLE FOR ANY DAMAGES RESULTING FROM LOSS OF USE, DATA, OR PROFITS WHETHER
							DIRECT OR INDIRECT OR FOR ANY INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
							DAMAGES, ARISING OUT OF OR IN CONNECTION WITH THE USE OF THE OLLIE WEBSITE, WHETHER OR NOT
							THE NEW BUSINESS COMMUNITY LAW CLINIC, OR BERKELEY LAW, OR ANY OF ITS AFFILIATES HAVE BEEN
							ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
						</p>
					</div>
				</DialogContainer>
			</span>
		);
	}
}

export default TermsModal;



// WEBPACK FOOTER //
// ./src/components/TermsModal.js